import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SiteTypeEnum } from 'src/app/shared/enums';
import { BasicService } from 'src/app/shared/services/basic.service';

import { AddAccountService } from '../add-account.service';
import { AuthorizedDataPage, AuthorizedDataParams } from '../shared/models';

/**
 * Common component to finalize connection to an account, when coming back from channel, after clicking the account in AddAccountComponent.
 * Used for channels that need simple connection process : facebook, linkedin, tiktok...
 * Correspond to AJS components AddAccount<Channel>, but name changed for less ambiguity with AddAccountComponent.
 */
@Component({
  selector: 'app-finalize-add-account',
  templateUrl: './finalize-add-account.component.html',
  styleUrls: ['./finalize-add-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FinalizeAddAccountComponent implements OnInit {
  @Input() authId: string = null;
  @Input() code: string = null;
  @Input() siteId: string = null;
  @Input() siteType: SiteTypeEnum;

  pages: AuthorizedDataPage[];
  add_page_url: string;
  prettyChannelName: string;

  form = this.formBuilder.group({
    rid: [null, Validators.required], // rid = request id
  });

  constructor(
    private addAccountService: AddAccountService,
    private alcmeonContextService: AlcmeonContextService,
    private basicService: BasicService,
    private formBuilder: FormBuilder,
    @Inject('$state') private $state: any,
    @Inject('TopToolbarFactory') private topToolbarService: any
  ) {}

  ngOnInit(): void {
    this.basicService.showSpinner();
    this.prettyChannelName = this.basicService.translate(`account_type/${this.siteType}`);

    this.basicService.translate(`account_type/${this.siteType}`),
      this.topToolbarService.setTitle(
        this.basicService.translate('add-account/common/title', { channel: this.prettyChannelName }),
        null
      );

    const data: AuthorizedDataParams = {
      auth_id: this.authId,
      site_id: this.siteId,
      code: this.code,
    };

    this.addAccountService
      .getAuthorizedData(this.siteType, data)
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe({
        next: response => {
          // TODO when migrating other channels (facebook and linkedin) that will use this component, redirect with states, needs backend evo
          if (response.reauth) {
            this.alcmeonContextService.redirectWithJwtShort(response.redirect_url);
          }
          // error in success response = 💩, TODO change BE
          else if (response.error) {
            const url = `${response.redirect_url}?error=${response.reason}`;
            this.alcmeonContextService.redirectWithJwtShort(url);
          } else {
            this.pages = response.pages;
            this.add_page_url = response.add_page_url;
          }
        },
      });
  }

  connect() {
    this.addAccountService.finalizeAddAccount(this.siteType, this.form.value).subscribe({
      next: siteId => {
        this.basicService.toastSuccess('add-account/common/connect-success');
        this.$state.go('auth.alcmeon.fuse.account-edit', { id: siteId });
      },
    });
  }
}
